import { t } from '../../i18n';

export default (message) => window.ModalHelper.showDangerMessage({
  title: t('javascript.error_page.error'),
  message,
  iconClosable: true,
  icon: false,
});
